import styled from "styled-components";
import { Grid, Button, Typography } from "@material-ui/core";

export const STGrid = styled(Grid)`
   {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const STButton = styled(Button)`
  && {
    text-transform: none;
    margin: 8px;
  }
`;

export const STContentGrid = styled(Grid)`
  && {
    padding-top: 24px;
    padding-bottom: 36px;
  }
`;

export const STLinkText = styled(Typography)`
  && {
    text-decoration: underline;
    color: blue;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
